import React from 'react'
import styled from 'styled-components'
import Image from '../image/Image'


interface IAudioProps {
  source: string
  thumbnail: string
}

const Audio = ({ source, thumbnail }: IAudioProps) => {
  return (
    <div style={{ position: 'relative' }}>
      <Image source={thumbnail} preset="preview" />
      <StyledAudio  controls>
        <source src={source} />
        Your browser does not support the audio tag.
      </StyledAudio>
    </div>
  )
}

export default React.memo(Audio)

const StyledAudio = styled.audio.attrs(
  (props: { maxWidth: string; maxHeight: string }) => props,
)`
  width: ${({ maxWidth }) => maxWidth};
  max-height: ${({ maxHeight }) => maxHeight};
`